import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import {
  Button,
  Grid,
  TextareaAutosize,
  Typography,
  Box,
  Modal,
} from "@material-ui/core";
import Backbutton from "../../Backbutton";
import { Formik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { connect } from "react-redux";

import SweetAlert from "react-bootstrap-sweetalert";
import ImageUploader from "react-images-upload";
import FormData from "form-data";
import { CircularProgress } from '@material-ui/core';

let schema = yup.object({
  brandalias: yup.string().required("Brand Alias is Required"),
  brandname: yup.string().required("Brand Name is Required").typeError(""),
  description: yup.string().typeError(""),
});

function BrandAdd({ server, history, access_token, role }) {

  const [errortext, seterrortext] = useState("");
  const [alert, setAlert] = useState(null);
  const [image, setImage] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [onLoading, setOnLoading] = React.useState(false);
  const [categories, setCategories] = React.useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = React.useState([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {

    getCategories();

    if (role?.id !== 1) {
      if (role?.id === 2) {
        history.push("/Distributer");
      }
      if (role?.id === 3) {
        history.push("/Retailer");
      }
      if (role?.id === 4) {
        history.push("/Games");
      }
    }
    
  }, []);

  const getCategories = () => {

    fetch(
      global.backendUrl + "/api/get-all-categories")
      .then((res) => res.json())
      .then((json) => {
        setCategories(json.categories);
      })
  };


  function removeItemOnce(arr, value) {

    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  const handleChangeCheckbox = (e) => {

    if (e.target.checked == true && !(selectedCategoryIds.includes(e.target.name))) {
      var tmp = selectedCategoryIds;
      tmp.push(e.target.name);
      setSelectedCategoryIds(tmp);
    } else {

      var tmp = selectedCategoryIds;
      if (selectedCategoryIds.includes(e.target.name)) {
        tmp = removeItemOnce(tmp, e.target.name);
      }
      setSelectedCategoryIds(tmp);
    }
  }


  const hideAlert = () => {
    setAlert(null);
  };
  
  const added = () => {
    setAlert(
      <SweetAlert success title="Added" onConfirm={hideAlert}>
        Brand has been created
      </SweetAlert>
    );

    history.push('/Brand')
  };
  const addNewBrand = (values, resetForm) => {

    setOnLoading(true);

    const bodyParameters = {
      alias: values.brandalias,
      name: values.brandname,
      description: values.description,
    };

    const config = {
      headers: { Authorization: `Bearer ${access_token}` },
    };

    const data = new FormData();

    Object.keys(bodyParameters).forEach((key) => {
      data.set(key, bodyParameters[key]);
    });

    if (image && !image.includes("storage")) {
      data.append("brand_image_file", image[0]);
    }

    data.append('category_ids', selectedCategoryIds.join(","))

    axios
      .post(server + "api/brand", data, config)
      .then((response) => {
        added();
        resetForm();
        setImage(null);
        seterrortext("");
      })
      .catch((error) => {
        const errormessage = error.response.data.errors.alias[0];
        seterrortext(errormessage);
        setOnLoading(false);
      });
  };

  const handleImageChange = (picture) => {
    setImage(picture);
  };

  return (
    <div className="grayBackgroundBox">
      {alert}
      <div className="card container">
        <Formik
          initialValues={{
            brandname: "",
            brandalias: "",
            description: "",
          }}
          validationSchema={schema}
          onSubmit={(values, { resetForm }) => {
            addNewBrand(values, resetForm);
          }}
        >
          {({
            values,
            handleBlur,
            handleChange,
            handleSubmit,
            errors,
            touched,
            isSubmitting,
            isValid,
          }) => (
            <form className="container" onSubmit={handleSubmit}>
              <div>
                <Backbutton />
              </div>
              <div className="title">Add New Brand</div>
              <Grid container>
                <Grid item xs={12} md={6}>
                  <div>
                    <div className="row">
                      <div className="col-12 col-md-6 inputFieldContainer">
                        <TextField
                          className="inputField"
                          id="standard-basic"
                          label="Brand name*"
                          name="brandname"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.brandname}
                        />
                        {errors.brandname && (
                          <p style={{ color: "red" }}>{errors.brandname}</p>
                        )}
                      </div>
                      <div className="col-12 col-md-6 inputFieldContainer">
                        <TextField
                          className="inputField"
                          id="standard-basic"
                          label="Brand Slug*"
                          name="brandalias"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.brandalias}
                        />
                        {errors.brandalias && touched.brandalias && (
                          <p style={{ color: "red" }}>{errors.brandalias}</p>
                        )}
                        {errortext && (
                          <p style={{ color: "red" }}>{errortext}</p>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <p style={{ color: 'grey', marginTop: 30 }}>Applicable Categories</p>

                      <div className="col-12 43poicol-md-6 inputFieldContainer">

                        {categories.map((category, index) => (

                          <div>
                            <input type="checkbox" 
                                   id={category.id} 
                                   name={category.id} 
                                   onChange={handleChangeCheckbox} />
                            <label style={{ fontSize: 12 }} for={category.id}>{category.name}</label>
                          </div>

                        ))}
                      </div>
                    </div>


                    <div className="row">
                      <div className="col-12 43poicol-md-6 inputFieldContainer">
                        <TextField
                          className="inputField"
                          id="standard-basic"
                          label="Description"
                          name="description"
                          rows={4}
                          multiline
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.description}
                        />
                        {errors.description && touched.description && (
                          <p style={{ color: "red" }}>{errors.description}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>

                  <Box sx={{ p: 2, border: "1px dashed grey", mt: 5, ml: 5 }}>
                    <Typography variant="h6" gutterBottom component="div">
                      Brand feature image
                    </Typography>
                    <img
                      src={image != null ? URL.createObjectURL(image[0]) : ""}
                      alt="Brand Image not found"
                      width={"100%"}
                    />
                    <div style={{ textAlign: "center" }}>
                      <Button
                        className="formSubmit"
                        variant="contained"
                        type="button"
                        color="secondary"
                        onClick={handleOpen}
                      >
                        Select Image
                      </Button>
                    </div>
                  </Box>
                </Grid>
              </Grid>
              <div style={{ textAlign: "center" }} className="text-center mt-5">
                <Button
                  className="formSubmit"
                  variant="contained"
                  type="submit"
                  color="primary"
                  disabled={!isValid}
                  style={{backgroundColor:'#F05225'}}
                  disableElevation
                >
          {onLoading ? <CircularProgress style={{color:'white'}} /> : "Save Brand"}

                </Button>
              </div>
            </form>
          )}
        </Formik>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "40%",
              minWidth: "400px",
              background: "white",
              padding: "10px 20px",
            }}
          >
            <ImageUploader
              singleImage
              withPreview={true}
              withIcon={true}
              buttonText="Choose Brand Feature Image"
              onChange={handleImageChange}
              imgExtension={[".jpg", ".gif", ".png", ".gif"]}
              maxFileSize={5242880}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                className="formSubmit"
                variant="contained"
                type="submit"
                color="gray"
                onClick={handleClose}
              >
                Done
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  server: state.auth.server,
  access_token: state.auth.access_token,
  role: state.auth.role[0],
});

export default connect(mapStateToProps, {})(BrandAdd);
